<p-input-text :placeholder="name" v-model="model" mode="decimal"></p-input-text>